//MARK: Done
export const DEVICE = {
  DEVICE: {
    PAGE: "device/page/dashboard",
    ADD: "device/add",
    DELETE: "device/delete",
    DELETE_MANY: "device/delete/many",
    GET: "device/get",
    SET: {
      INDEX: "device/set",
      SPECIFICS: "device/set/specifics",
      IRRIGATOR_VALVES: "device/set/irrigator/valves",
    },
    BULK_UPLOAD: "device/bulk/upload",
    LIST: "device/list",
    GLOBAL: {
      SEARCH: "device/global/search",
    },
    DATA_QUALITY: {
      SET: "device/data-quality/set",
    },
    TRANSFER: {
      MANY: "device/transfer/many",
    },
    INHEMETER: {
      OTA_INIT: "device/inhemeter/ota-init",
      OTA_STATUS: "device/inhemeter/ota-status",
    },
  },
};
